import { FC } from 'react';

type SaveIconProps = {
  width?: number;
  height?: number;
} & React.SVGProps<SVGSVGElement>;

export const SaveIcon: FC<SaveIconProps> = ({ width = 20, height = 20, ...rest }) => (
  <svg width={width} height={height} {...rest} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_6445_1814)">
      <path d="M6.66602 18.3333V15.8333C6.66602 14.262 6.66602 13.4763 7.15417 12.9882C7.64232 12.5 8.42802 12.5 9.99935 12.5C11.5707 12.5 12.3563 12.5 12.8445 12.9882C13.3327 13.4763 13.3327 14.262 13.3327 15.8333V18.3333" stroke="white" strokeWidth="1.7" strokeLinejoin="round"/>
      <path d="M8.33398 5.83331H11.6673" stroke="white" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2.5 9.88202C2.5 6.06835 2.5 4.16149 3.65562 2.9533C3.69831 2.90867 3.74198 2.865 3.78662 2.8223C4.9948 1.66669 6.90166 1.66669 10.7153 1.66669C11.6192 1.66669 12.0546 1.66982 12.469 1.82449C12.8681 1.97344 13.2024 2.25201 13.871 2.80918L15.7009 4.33412C16.5856 5.07136 17.0279 5.43998 17.264 5.9439C17.5 6.44783 17.5 7.02363 17.5 8.17523V10.8334C17.5 13.9581 17.5 15.5205 16.7042 16.6158C16.4472 16.9695 16.1362 17.2806 15.7824 17.5376C14.6872 18.3334 13.1247 18.3334 10 18.3334C6.87522 18.3334 5.31283 18.3334 4.21756 17.5376C3.86383 17.2806 3.55276 16.9695 3.29576 16.6158C2.5 15.5205 2.5 13.9581 2.5 10.8334V9.88202Z" stroke="white" strokeWidth="1.7"/>
    </g>
    <defs>
      <clipPath id="clip0_6445_1814">
        <rect width="20" height="20" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);
